import { SidebarHeader } from "@/components/sidebar/components/SidebarHeader.tsx";

import { SidebarTeamBaseMenu } from "@/components/sidebar/team/SidebarTeamBaseMenu.tsx";
import { useTranslation } from "react-i18next";

export const SidebarTeam = () => {
  const { t } = useTranslation();

  return (
    <>
      <SidebarHeader title={t("core:people")} />
      <SidebarTeamBaseMenu />
    </>
  );
};
